@if(component) {
<div class="pos-relative">
    <div class="p-t-20 p-b-20 p-t-5-s p-b-5-s"
         [ngClass]="component.background_color || 'bg-col-w'">

        <div class="vc-outer">
            <div class="vc-inner">
                <div class="wrap flex-x flex-l flex-m"
                     [ngClass]="component.swap_position ? 'flex-reverse' :''">
                    <div class="w-6 w-12-s p-r-4-x p-r-4-l"
                         [ngSwitch]="component.variant">

                        <ng-container *ngSwitchCase="'image'">
                            <div class="ratio-4-3">
                                <img *ngIf="component.image"
                                     class="fill"
                                     [image]="component.image">
                            </div>
                        </ng-container>

                        <div class="ratio-4-3"
                             *ngSwitchCase="'video'">
                            <ng-container *ngIf="component.video_provider === 'vimeo' && component.video_url">
                                <vimeo-player class="full-video-wrapper"
                                              [video-id]="component.video_url"
                                              [controls]="false">
                                    <!-- play icon -->
                                    <ng-template #playButton>
                                        <p class="opacity b-radius-max bg-col-w pos-relative"
                                           aria-role="button"
                                           [style.width.rem]="client.isX || client.isL ? 7.5 : 3.2"
                                           [style.height.rem]="client.isX || client.isL ? 7.5 : 3.2">
                                            <i class="pos-absolute top-0 bottom-0 left-0 right-0 flex flex-middle flex-justify-center icon-play col-1 p-l-2"
                                               aria-hidden="true"
                                               [style.font-size.rem]="client.isX || client.isL ? 2.6 : 1"></i>
                                        </p>
                                    </ng-template>
                                    <!-- pause icon -->
                                    <ng-template #pauseButton>
                                        <p class="opacity b-radius-max bg-col-w pos-relative"
                                           aria-role="button"
                                           [style.width.rem]="client.isX || client.isL ? 7.5 : 3.2"
                                           [style.height.rem]="client.isX || client.isL ? 7.5 : 3.2">
                                            <i class="pos-absolute top-0 bottom-0 left-0 right-0 flex flex-middle flex-justify-center icon-pause col-1"
                                               aria-hidden="true"
                                               [style.font-size.rem]="client.isX || client.isL ? 2.6 : 1"></i>
                                        </p>
                                    </ng-template>
                                </vimeo-player>
                            </ng-container>

                            <ng-container *ngIf="component.video_provider === 'youtube' && component.video_url">
                                <youtube-player class="full-video-wrapper"
                                                [video-id]="component.video_url"
                                                [autoplay-in-viewport]="true"
                                                [background]="true">
                                    <ng-template #playButton>
                                        <p class="opacity b-radius-max bg-col-w pos-relative"
                                           aria-role="button"
                                           [style.width.rem]="client.isX || client.isL ? 7.5 : 3.2"
                                           [style.height.rem]="client.isX || client.isL ? 7.5 : 3.2">
                                            <i class="pos-absolute top-0 bottom-0 left-0 right-0 flex flex-middle flex-justify-center icon-play col-1 p-l-2"
                                               aria-hidden="true"
                                               [style.font-size.rem]="client.isX || client.isL ? 2.6 : 1"></i>
                                        </p>
                                    </ng-template>
                                    <ng-template #pauseButton>
                                        <p class="opacity b-radius-max bg-col-w pos-relative"
                                           aria-role="button"
                                           [style.width.rem]="client.isX || client.isL ? 7.5 : 3.2"
                                           [style.height.rem]="client.isX || client.isL ? 7.5 : 3.2">
                                            <i class="pos-absolute top-0 bottom-0 left-0 right-0 flex flex-middle flex-justify-center icon-pause col-1"
                                               aria-hidden="true"
                                               [style.font-size.rem]="client.isX || client.isL ? 2.6 : 1"></i>
                                        </p>
                                    </ng-template>
                                </youtube-player>
                            </ng-container>
                        </div>
                    </div>
                    <div class="w-6 w-12-s m-r-0 p-l-5 p-l-0-s m-t-4-s">
                        <div class="vc-outer p-l-10-x p-l-10-l">
                            <div class="vc-inner p-l-10-x p-l-10-l"
                                 [ngClass]="component.horizontal_text_align || 'left'">

                                <ng-container *ngIf="component.header">
                                    <p class="o1 col-11"
                                       *iCms="'header' of component; content: 'html'"></p>
                                </ng-container>

                                <ng-container *ngIf="component.title">
                                    <p sizeClass="S:h2, !S:h1"
                                       class="m-t-2 col-1"
                                       *iCms="'title' of component; content: 'html'"></p>
                                </ng-container>

                                <ng-container *ngIf="component.subtitle">
                                    <p sizeClass="S:p2, !S:p1"
                                       class="m-t-2 col-11 w-9-x w-9-l"
                                       *iCms="'subtitle' of component; content: 'html'"></p>
                                </ng-container>

                                <div class="m-t"
                                     *ngIf="component.cta_copy">
                                    <a [routerLink]="component.cta_link"
                                       class="button-inline"
                                       *iCms="'cta_copy' of component"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

}